import { useState } from "react";

export default function Box({ children }) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className=" rounded-md  text-white w-1/2 min-h-screen bg-background500 relative s">
      <button
        className="bg-background900 w-5 h-5 flex justify-center items-center rounded-full absolute right-1 top-1 text-2xl "
        onClick={() => setIsOpen((p) => !p)}
      >
        {isOpen ? "-" : "+"}
      </button>
      {isOpen && children}
    </div>
  );
}
